import React from "react";
import { ArrowRight, CheckCheck, Loader2, Pencil } from "lucide-react";
import { Button } from "src/shadcn/ui/button";
import { RelabelCaseRecord, RelabelCaseTrackingTabKey } from "src/types";

interface ActionCellProps {
  case_: RelabelCaseRecord;
  tab: RelabelCaseTrackingTabKey;
  isLoading: boolean;
  onAction: (case_: RelabelCaseRecord) => void;
  onEditQtyAction?: (case_: RelabelCaseRecord) => void;
}

const ActionCell: React.FC<ActionCellProps> = ({ case_, tab, isLoading, onAction, onEditQtyAction }) => {
  const editButton = onEditQtyAction && (
    <Button
      size="sm"
      variant="outline"
      disabled={isLoading}
      onClick={() => onEditQtyAction(case_)}
      title="Edit product quantity"
      className="h-8 w-8 p-0 border-secondary-300 text-secondary-700 hover:bg-secondary-100"
    >
      <Pencil className="h-3.5 w-3.5" />
    </Button>
  );

  if (tab === "scan-in") {
    return (
      <div className="flex items-center justify-end gap-2">
        {editButton}
        <Button
          size="sm"
          disabled={isLoading}
          onClick={() => onAction(case_)}
          className="bg-blue-600 hover:bg-blue-700 text-white text-xs h-8 px-3 gap-1.5"
        >
          {isLoading ? <Loader2 className="h-3 w-3 animate-spin" /> : <ArrowRight className="h-3 w-3" />}
          {isLoading ? "Scanning..." : "Scan In"}
        </Button>
      </div>
    );
  }

  const isStandard = case_.routingType === "EU_STANDARD";
  return (
    <div className="flex items-center justify-end gap-2">
      {editButton}
      <Button
        size="sm"
        disabled={isLoading}
        onClick={() => onAction(case_)}
        className={`text-xs h-8 px-3 gap-1.5 ${
          isStandard ? "bg-indigo-600 hover:bg-indigo-700 text-white" : "bg-emerald-600 hover:bg-emerald-700 text-white"
        }`}
      >
        {isLoading ? <Loader2 className="h-3 w-3 animate-spin" /> : <CheckCheck className="h-3 w-3" />}
        {isLoading ? "Updating..." : isStandard ? "Confirm Ready" : "Mark Complete"}
      </Button>
    </div>
  );
};

export { ActionCell };
